import { Outlet, ScrollRestoration, useLocation } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { Fragment } from "react";
import "./Layout.scss";

function Layout() {
    const location = useLocation();

    return (
        <Fragment>
            <Navbar />
            <div className="layout">
                <ScrollRestoration />
                {/* <Outlet /> */}
                <div key={location.pathname}>
                    <Outlet />
                </div>
            </div>
            <Footer />
        </Fragment>
    )
}

export default Layout;